export const STORAGE_KEYS = {
  SECTION_PREFIX: 'volca-drum-section-',
  DARK_MODE: 'volca-drum-dark-mode',
  DEBUG_MODE: 'volca-drum-debug-mode',
} as const;

export function getSectionStorageKey(sectionId: string): string {
  return `${STORAGE_KEYS.SECTION_PREFIX}${sectionId}`;
}
